// document.addEventListener("DOMContentLoaded", () => {
//   document.addEventListener("click", function (e) {
//     const dummyButton = e.target.closest(".custom-add-to-cart");
//     if (!dummyButton) return;
//     e.preventDefault();
//     const originalButton = document.querySelector(
//       '.product-form__submit[name="add"]'
//     );
//     if (originalButton && !originalButton.disabled) {
//       originalButton.click();
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", () => {

  function syncDummyButton() {
    const realButton = document.querySelector(".product-form__submit");
    const dummyButton = document.querySelector(".custom-add-to-cart");

    if (!realButton || !dummyButton) return;

    dummyButton.innerHTML = realButton.innerHTML;
    dummyButton.disabled = realButton.disabled;
  }

  syncDummyButton();

  document.addEventListener("variant:change", syncDummyButton);

  const observer = new MutationObserver(syncDummyButton);

  const realButton = document.querySelector(".product-form__submit");

  if (realButton) {
    observer.observe(realButton, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["disabled"]
    });
  }

  document.addEventListener("click", function (e) {
    const dummy = e.target.closest(".custom-add-to-cart");
    if (!dummy) return;

    e.preventDefault();

    const realButton = document.querySelector(".product-form__submit");

    if (realButton && !realButton.disabled) {
      realButton.click();
    }
  });

});